module.exports = __webpack_public_path__ + "static/media/highlight-black.93dcb7ca.png";